export const GET_MEASUREMENTS = 'GET_MEASUREMENTS';
export const LOADING_MEASUREMENTS = 'LOADING_MEASUREMENTS';
export const SAVE_LOADER_MEASUREMENTS = 'SAVE_LOADER_MEASUREMENTS'